import { Transactions } from "./components/Transactions";
import { UnlinkCompany } from "./components/UnlinkCompany";
import { Home } from "./components/Home";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/transactions',
        element: <Transactions />
    },
    {
        path: '/unlinkcompany',
        element: <UnlinkCompany />
    }
];

export default AppRoutes;
